import { Alert } from "@mui/material";
import { FC } from "react";
import { ListOfPartnerOrganisations } from "../../../../redux/slices/shareSite/shareSiteTypes";
import { useTranslation } from "react-i18next";

type ShareSiteShowErrorParams = {
  errorFetchPartnerOrganisations: string;
  storagesError: string;
  sharingstatusError: string;
  listOfPartnerOrganisations: ListOfPartnerOrganisations | undefined;
};

const ShareSiteShowErrors: FC<ShareSiteShowErrorParams> = ({
  errorFetchPartnerOrganisations,
  storagesError,
  sharingstatusError,
  listOfPartnerOrganisations,
}) => {
  const [t] = useTranslation("global");
  if (
    errorFetchPartnerOrganisations?.length >= 1 ||
    storagesError?.length >= 1 ||
    sharingstatusError?.length >= 1
  ) {
    return (
      <Alert severity="error" className="mt-4">
        {errorFetchPartnerOrganisations} {storagesError} {sharingstatusError}
      </Alert>
    );
  }
  if (listOfPartnerOrganisations?.total === 0) {
    return (
      <Alert severity="warning" className="mt-4">
        {t("Share_site.no_partners")}
      </Alert>
    );
  } else {
    return "";
  }
};

export default ShareSiteShowErrors;
